import { IInterest } from "api/types";
import format from "date-fns/format";
import subYears from "date-fns/subYears";
import { useState } from "react";
import { getSelectedSegmentationDetailIds } from "screens/Onboarding/Onboarding.utils";

export function useCustomer() {
  const [interests, setInterests] = useState<IInterest[]>([]);
  const [usageTypes, setUsageTypes] = useState<IInterest[]>([]);
  const [pin, setPin] = useState("");
  const [phoneNumber = "", setPhoneNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [birthday, setBirthday] = useState("");
  const interestIds = getSelectedSegmentationDetailIds(interests);
  const usageTypeIds = getSelectedSegmentationDetailIds(usageTypes);

  const clearCustomerState = () => {
    setInterests([]);
    setUsageTypes([]);
    setPhoneNumber("");
    setPin("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setZipcode("");
    setBirthday("");
  };

  return {
    customer: {
      firstName,
      lastName,
      phoneNumber,
      email,
      birthday,
      zipcode,
      pin,
      interestIds,
      usageTypeIds
    },
    interests,
    usageTypes,
    clearCustomerState,
    setters: {
      setZipcode,
      setFirstName,
      setLastName,
      setEmail,
      setBirthday,
      setUsageTypes,
      setInterests,
      setPin,
      setPhoneNumber
    }
  };
}



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Onboarding.hooks.ts